import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './layout/layout.module.scss';
import { Sidebar } from './Sidebar';
import { Rightbar } from './Rightbar';

export class Layout extends Component {
  render() {
    const {
      className,
      sidebarClassName,
      rightbarClassName,
      mainClassName = '',
      opened = true,
      toggleSidebar,
      sidebar,
      children,
      zoomOnResize = false,
      isRightbarOpen = true,
      isRightbarExpanded = false,
      toggleRightbar,
      rightbarChildren,
    } = this.props;

    const containerClassNames = [styles.container];

    if (opened) {
      containerClassNames.push(styles._sidebarOpened);
      if (zoomOnResize) {
        const width = window.innerWidth;
        if (width > 959 && width < 1281) {
          containerClassNames.push(styles._sidebarPadding);
        }
      }
    }
    if (rightbarChildren && isRightbarOpen) {
      containerClassNames.push(styles._rightbarOpened);
    }
    if (className) {
      containerClassNames.push(className);
    }

    return (
      <div className={containerClassNames.join(' ')}>
        <Sidebar
          className={sidebarClassName}
          isOpen={opened}
          zoomOnResize={zoomOnResize}
          toggleSidebar={toggleSidebar}
        >
          {sidebar}
        </Sidebar>
        <main className={`${styles.main} ${mainClassName}`}>
          {children}
        </main>
        {rightbarChildren &&
          <Rightbar
            className={rightbarClassName}
            isOpen={isRightbarOpen}
            isExpanded={isRightbarExpanded}
            toggleRightbar={toggleRightbar}
          >
            {rightbarChildren}
          </Rightbar>
        }
      </div>
    );
  }
}

Layout.propTypes = {
  className: PropTypes.string,
  sidebarClassName: PropTypes.string,
  rightbarClassName: PropTypes.string,
  mainClassName: PropTypes.string,
  opened: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  sidebar: PropTypes.element,
  isRightbarOpen: PropTypes.bool,
  isRightbarExpanded: PropTypes.bool,
  toggleRightbar: PropTypes.func,
  rightbarChildren: PropTypes.element,
};
